export const formatBytes = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatSpeed = (bytesPerSecond) => {
  return formatBytes(bytesPerSecond) + '/s';
};

export const formatTimeRemaining = (totalBytes, uploadedBytes, speed) => {
  if (speed === 0 || uploadedBytes === 0) return 'Calculating...';
  const remainingBytes = totalBytes - uploadedBytes;
  const remainingSeconds = remainingBytes / speed;

  if (remainingSeconds < 60) {
    return `${Math.round(remainingSeconds)}s remaining`;
  } else if (remainingSeconds < 3600) {
    return `${Math.round(remainingSeconds / 60)}m remaining`;
  } else {
    return `${Math.round(remainingSeconds / 3600)}h remaining`;
  }
};

export const formatDateTime = (dateTime) => {
  return new Date(dateTime).toLocaleString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Kolkata',
    timeZoneName: 'short'
  });
};
